import * as React from 'react';
import { MobileProductDetailsCell } from '../../cells/product-details/mobile-items';
import { OperationItemRowBase } from './base-row';
import { Props } from './props';
import { StatusCell } from '../../cells/status/component';
import { Table } from 'semantic-ui-react';

export class MobileRow extends OperationItemRowBase {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <Table.Row className={(this.props.isActive ? 'active-row ' : '') + 'inner-operation-item-row mobile'}
        onClick={this.props.onClick}>
        <Table.Cell width={11}>
          <MobileProductDetailsCell operationItem={this.props.operationItem} language={this.props.language} />
        </Table.Cell>
        <Table.Cell textAlign="center" width={5}>
          <StatusCell operationItem={this.props.operationItem} isOnline={this.props.isOnline} language={this.props.language} />
        </Table.Cell>
      </Table.Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/row/mobile-row.tsx